





































import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace, Action} from "vuex-class";

import Maps from '@/views/components/Maps/Maps.vue';
import {IHub, initialHub} from "@/models/StoreModels";

const hubsModule = namespace("hubs");

@Component({
  name: 'SelectDefaultHub',
  components: {
    Maps,
  },
})
export default class SelectDefaultHub extends Vue {
  @hubsModule.Getter("getHubList")
  private hubList!: IHub[];

  @hubsModule.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  @Action("setDefaultHubId")
  private setDefaultHubId!: (id: number) => void;


  private loading: boolean = false;
  private myHub: IHub = initialHub();
  private errors: string = "";

  private updateSelectedHub(hub: IHub) {
    this.setDefaultHubId(hub.id);
  }

  private goBack() {
    this.$emit("selectDefaultHub:back");
  }

  private selectThisHub(newHub: IHub) {
    this.myHub = newHub;
    this.updateSelectedHub(this.myHub);
    this.$emit("selectDefaultHub:back", true);
  }

}
